import React, { useEffect, useImperativeHandle, useRef, forwardRef } from 'react';
import { Input } from 'antd';
import type { InputRef } from 'antd';

const TeamMemberEditor = forwardRef((props: any, ref) => {
    const inputRef = useRef<InputRef>(null);
    const valueRef = useRef(props.value?.split('@')[0] || '');

    useEffect(() => {
        setTimeout(() => {
            inputRef.current?.focus?.();
        });
    }, []);

    useImperativeHandle(ref, () => ({
        getValue: () => {
            let value = valueRef.current;
            if (value.includes('@')) {
                value = value.split('@')[0];
            }
            return value;
        },
        isCancelBeforeStart: () => false,
        isCancelAfterEnd: () => false
    }));

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.target.value;
        const atIndex = inputValue.indexOf('@');
        const sanitizedValue = atIndex !== -1 ? inputValue.slice(0, atIndex) : inputValue;

        valueRef.current = sanitizedValue;

        // Forcefully update the input field value
        if (inputRef.current?.input) {
            inputRef.current.input.value = sanitizedValue;
        }
    };

    const handleBeforeInput = (e: React.FormEvent<HTMLInputElement>) => {
        const input = e.nativeEvent as InputEvent;
        if (input.data?.includes('@')) {
            e.preventDefault(); // Stop from typing "@"
        }

        // Prevent typing if "@" already exists in the value
        const current = inputRef.current?.input?.value || '';
        if (current.includes('@')) {
            e.preventDefault();
        }
    };

    const handleBlur = () => {
        props.stopEditing();
    };

    return (
        <Input
            ref={inputRef}
            defaultValue={props.value}
            onChange={handleChange}
            onBeforeInput={handleBeforeInput}
            onBlur={handleBlur}
            addonAfter={`${props?.data?.domain}`}
        />
    );
});

export default TeamMemberEditor;